//
//
//
//
//
//

export default {
  name: 'CycleAside'
}
